/**
 * Aviso antes de confirmar una campaña con una promoción que no dice cómo darse de baja (pedido de Alan
 * del 16/10/2026: no obligar, pero avisar). No frena nada: la campaña se confirma igual. Las bajas que
 * llegan se procesan con o sin el pie.
 */
import { AlertTriangle } from "lucide-react";
import { avisosDeBaja } from "../logic/baja";
import type { PlantillaConBaja } from "../logic/baja";

export function AvisoBaja({ plantilla }: { plantilla?: PlantillaConBaja }) {
  const avisos = plantilla ? avisosDeBaja(plantilla) : [];
  if (!avisos.length) return null;
  return (
    <div role="note" className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <p className="flex items-center gap-2 font-semibold">
        <AlertTriangle size={15} className="flex-shrink-0" /> Esta promoción no tiene cómo darse de baja
      </p>
      <ul className="mt-1.5 list-disc pl-5 space-y-0.5 text-xs">
        {avisos.map((a) => <li key={a}>{a}</li>)}
      </ul>
      <p className="mt-1.5 text-xs">Podés seguir igual. Quien responda BAJA o pida la baja queda dado de baja de todos modos.</p>
    </div>
  );
}

export default AvisoBaja;
